const strings = {
  abcya: ["ABCya", "ABCya!"],
  about: {
    title: ["ABOUT ABCya", "About ABCya", "ABOUT ABCYA"],
  },
  accountComplete: {
    title: "WELCOME TO ABCYA!",
    subTitle: "You have successfully subscribed!",
    sectionTitle: {
      family: "Last step: Create your account.",
      classSchool: "Complete your setup to start using ABCya with your students.",
    },
    form: {
      classSchool: {
        title: "Create Your Login Password",
        text: "You will use this email and password to manage your ^ subscription.",
        student: {
          title: "Set Up Student Login",
          text: "Create a simple access name and code for your students to use.",
          namePlaceholder: "e.g. tigers2026",
          codePlaceholder: "e.g. Tigers123",
        },
      },
      cta: {
        family: "CREATE ACCOUNT",
        classSchool: "COMPLETE SETUP",
      },
    },
  },
  adblock: {
    content: "Can't see the ^? Try turning off adblocker.",
  },
  ads: {
    ad: "Advertisement",
    go: "Go Ad-Free!",
  },
  ageGate: {
    message: "Enter your date of birth to continue",
    title: "Grown-ups",
    select: {
      year: "YYYY",
      day: "DD",
      month: "MM",
    },
  },
  all: ["ALL", "All"],
  // applied: "APPLIED",
  // apply: "APPLY",
  annual: ["Annual"],
  appStores: {
    AMAZON: "Amazon App Store",
    ANDROID: "Google Play Store",
    IOS: "Apple App Store",
  },
  attention: ["Attention"],
  back: ["BACK"],
  blog: {
    bodyError: "There was an error retrieving the body content for this blog post.  Please check back soon.",
    featured: "Featured Blog Post",
    go: "View blog posts",
    posted: "Posted on ^",
    recentTitle: "Recent Entries",
    search: "Search Blog Posts",
    title: ["ABCya BLOG", "BLOG", "BLOG POSTS", "blog post", "Blog"],
  },
  browse: ["browse"],
  browseLibrary: "BROWSE OUR LIBRARY",
  cancel: ["cancel", "Cancel", "Canceling", "Canceled", "CANCEL"],
  categoryGames: {
    title: "Games Category",
  },
  checkPass: "Checking Password",
  choose: ["CHOOSE"],
  classroom: "Classroom",
  contact: ["Contact Us", "CONTACT US"],
  continue: ["CONTINUE"],
  cookieBanner: {
    title: "ABCya Privacy and Cookies",
    message:
      'ABCya uses cookies in order to offer the best experience of our website. Please review our <a href="/privacy">Privacy Policy</a> for more information.',
    shortname: "make-a-cookie",
  },
  copyright: "Copyright ^ ABCya.com, L.L.C., a division of IXL Learning • All Rights Reserved",
  cost: ["Cost"],
  currencySymbol: {
    usd: "$",
  },
  delete: ["Deleting", "Deleted"],
  dismiss: ["DISMISS"],
  done: ["DONE"],
  education: {
    title: "Education.com",
  },
  educatorInfo: "Educator Info",
  educatorInfoErrorMessage: "Educator info data fetch error: ^",
  emailPreferences: {
    form: {
      subscribe: "Game recommendations",
      unsubscribe: "Unsubscribe from all emails",
    },
    instructions: "Choose which emails you would like to receive from ABCya:",
    manage: {
      button: "Email Preferences",
    },
    notFound: `Your email preferences have not been set up yet. Please check back later or contact support at <a href="mailto:support@abcya.com" rel="noopener noreferrer" target="_blank">support@abcya.com</a>.`,
    success: {
      title: {
        subscribed: "Subscribe Successful",
        unsubscribed: "Unsubscribe Successful",
      },
      message: {
        subscribed: "Success: Your email preferences have been saved.",
        unsubscribed: "You have been successfully unsubscribed from our emails.",
      },
    },
    title: ["EMAIL PREFERENCES", "Email Preferences"],
  },
  emmersion: {
    title: "Emmersion",
  },
  error: ["ERROR"],
  expire: ["expire"],
  externalServiceDown:
    "We are experiencing technical difficulties at the moment, and some features, such as logging in and signing up, may not work. We apologize for the inconvenience, and are working on restoring full functionality.",
  family: "Family",
  faq: {
    feedback: {
      cta: "We love getting feedback from our community! Please be descriptive; the more info you provide, the more we can help.",
      error: {
        message: ["Sorry! Your message has not been sent."],
      },
      game: "Having trouble with a specific game?",
      question: "Didn't find an answer? Contact us.",
      success: {
        message: [
          "Thanks! Your message has been sent. We'll be in touch soon.",
          "Thanks! Your message has been sent. We'll be in touch at the email address associated with your ABCya account.",
        ],
        title: "Message Sent",
      },
      terms:
        'By clicking SEND, you certify that you have read and agreed to our <a href="/privacy" rel="noopener noreferrer" target="_blank">Privacy Policy</a>.',
      title: ["Message", "Comments & Questions"],
    },
    title: ["HELP / FAQs", "FAQs"],
  },
  first: ["FIRST"],
  footer: {
    affiliate: "Affiliates",
    content: "OUR CONTENT",
    featured: {
      title: "Featured in",
      outlets: ["The New York Times", "Apple", "USA Today", "Parents", "Scholastic", "Fox News"],
    },
    games: ["^ Games", "Grade ^ Games"],
    brands: {
      ixl: "Comprehensive K-12 personalized learning",
      rosetta: "Immersive learning for 25 languages",
      vocabulary: "Adaptive learning for English vocabulary",
      education: "35,000 worksheets, games, and lesson plans",
      wyzant: "Trusted tutors for 300+ subjects",
      spanishIngles: "Spanish-English dictionary, translator, and learning",
      emmersion: "Fast and accurate language certification",
      tpt: "Marketplace for millions of educator-created resources",
    },
    languageMenu: {
      la: "Navegar en español",
    },
  },
  forgot: {
    caption: [
      "To reset your password, enter the email address for your&nbsp;account.",
      "<p>Reset instructions have been emailed to you.</p><p><strong>If you cannot locate the email in your inbox, please check your junk/spam folder.</strong></p>",
    ],
    loading: "Submitting Reset",
    metaTitle: "Forgot Password",
    subtitle: "Send Reset Email",
    title: "FORGOT PASSWORD",
  },
  forms: {
    accessCode: "Access Code",
    accessName: "Access Name",
    address: ["Address"],
    answer: "Answer",
    cardNumber: "Card Number",
    expires: "Exp.",
    cvc: "CVC",
    city: ["City"],
    code: ["Code", "Temporary Code"],
    country: ["Country"],
    currentPassword: "Current Password",
    deviceCount: ["Number of Devices", "Number of devices"],
    email: ["Email Address", "Email Address / Access Name", "Email address", "Email", "Adult's Email Address"],
    teacherEmail: ["Teacher's Email Address"],
    emailVerify: "Confirm Email",
    adultEmailVerify: "Confirm Adult's Email",
    teacherEmailVerify: "Confirm Teacher's Email Address",
    feedback: "Feedback",
    getAQuote: "GET YOUR QUOTE",
    name: ["Name"],
    newPassword: ["New Password", "New passwords"],
    newPasswordVerify: "New Password Verify",
    password: ["Password", "Password / Access Code", "Create Password"],
    passwordVerify: "Confirm Password",
    phone: ["Phone Number", "Phone number"],
    phonePlaceholder: "XXX-XXX-XXXX",
    position: ["Position"],
    positionPlaceholder: "Your Position",
    schoolAddress: ["School/District Address", "School/District address"],
    schoolName: ["School/District Name", "School/District name"],
    select: ["Select..."],
    state: ["State"],
    studentCount: ["Number of Students", "Number of students"],
    yourContact: "Your Contact Information",
    yourDistrictSchool: "Your School/District",
    errorMessages: {
      email: ["^ must contain a valid email address."],
      mustMatch: ["^ must match."],
      isRequired: ["^ is required."],
      isTooLong: "^ must have at most ^ characters.",
      isTooShort: "^ must have at least ^ characters.",
      nonAlphaNumericHyphenUnderscore:
        "^ can only contain lowercase letters, numbers, and underscores, and must not include spaces.",
    },
  },
  free: ["Free", "FREE"],
  freeGames: {
    title: "Free Games of the Week",
    subtitle: "Check back every week for six new FREE games",
  },
  game: {
    favorites: {
      add: "Add Favorite",
      adding: "Adding to Favorites",
      mine: "My Favorite!",
      publicLimit: ["Want to add more favorite games? Get your membership today!", "Want to add more favorite games?"],
      remove: "Remove Favorite",
      removing: "Removing from Favorites",
      signup: "Get a membership to save all your favorite games!",
    },
    fullscreen: {
      incompatible: {
        message: "The browser you are using doesn't support fullscreen mode. Please try a different browser.",
        title: "Incompatible Browser",
      },
      signup: "Get a membership to play games in Fullscreen mode!",
      title: ["Fullscreen"],
      upgrade: "Upgrade to play your favorite games in Fullscreen mode.",
    },
    go: "Go to All Games page",
    mobile: {
      exit: "Exit?",
      find: "Find mobile games",
      notAvailable: "Sorry, this game isn't available on mobile&nbsp;yet.",
      play: "PLAY ALL OUR GAMES ON DESKTOP ANYTIME!",
    },
    similar: "SIMILAR GAMES",
    title: ["game", "Game", "GAME"],
    trouble: "Trouble Playing This Game?",
    educatorInfo: {
      skills: "Skills Practiced",
      recommended: "Recommended For",
      info: "Game Info",
      warmUp: "Suggested Warm-Up",
      followUp: "Suggested Follow-Up",
    },
  },
  games: {
    all: ["ALL GAMES", "Visit All Games"],
    title: ["Games", "GAMES"],
    by: "Games by ^",
  },
  giftcard: {
    // another: "apply another gift card",
    // applying: "Applying Gift Card",
    checking: "Checking Gift Card",
    choose: {
      amount: {
        enter: "Enter Amount",
        rules: "Minimum amount is $10. Maximum is $500. Must be in increments of $5.",
        title: "Choose Amount:",
      },
      design: "Choose Gift Card Design",
    },
    claim: {
      example: "XXXXXXXXXXXXXXXX",
      title: "Claim Code:",
    },
    complete: "COMPLETE PURCHASE",
    confirm: {
      message: "Gift Cards Purchase",
      recipients: "Recipients",
      design: "Design",
    },
    details: "Gift Card Details",
    disclaimer: "Gift cards are nonrefundable.",
    emailError: "Gift card ^ email",
    errors: {
      // applied: "The gift card code supplied has already been applied",
      invalid: "The gift card code supplied is invalid",
      // max: "The amount for the gift card supplied would exceed the maximum redemption amount of $^",
      redeemed: "The gift card code supplied has already been redeemed.",
    },
    from: {
      email: ["Your Email", "email"],
      name: ["Your Name"],
      title: "From:",
    },
    message: "Message:",
    messageError: "Gift card ^ message",
    optional: "(Optional)",
    preview: "PREVIEW CARD(S)",
    purchase: ["PURCHASE GIFT CARDS", "PURCHASE CARD(S)", "Purchase Gift Cards"],
    quantity: "Quantity",
    recipientEmail: "Recipient Email:",
    redeem: ["REDEEM GIFT CARDS", "Redeem Gift Cards"],
    redeemed: ["Your gift card codes have been redeemed."],
    subtitle: "ABCya Gift Card",
    success: {
      message: {
        contact: 'Please feel free to <a href="/support">contact us</a> if you have any questions.',
        receipt: "An email receipt with the gift card(s) will be sent to ^.",
        recipients: "The $^ gift card(s) will also be sent to ^.",
      },
      title: "Thank you for purchasing an ABCya Gift Card!",
    },
    title: ["Give the Gift of ABCya!", "GIFT CARD", "Gift Card"],
    total: ["Gift cards applied total: ^", "Gift Card(s) Total:"],
  },
  grade: ["GRADE", "grade", "Grade", "Grades"],
  grades: {
    categories: {
      holiday: "^ HOLIDAY GAMES",
      letters: "^ WORD GAMES",
      numbers: "^ MATH GAMES",
      skill: "^ SKILL GAMES",
      strategy: "^ STRATEGY GAMES",
    },
    sorry: "I'm sorry, there are no games for this grade yet.  Please check back soon!",
    standards: "Grade ^ Common Core Standards",
    title: "GRADE ^",
    featured: "featured games",
    minibanner: "Grades ^ &ndash; ^",
    pre: "pre-",
    standardsCta: "For a full list of aligned Common Core standards, visit our Common Core page:",
  },
  head: {
    defaultTitle: "ABCya! • Learning Games and Apps for Kids",
    description:
      "Educational games for grades PreK through 6 that will keep kids engaged and having fun. Topics include math, reading, typing, just-for-fun logic games… and more!",
    keywords:
      "kids, educational, games, apps, elementary, primary, math, spelling, reading, letters, numbers, practice",
    schemaTitle: "ABCya! • ^",
    titleTemplate: "%s • ABCya!",
  },
  help: {
    title: ["HELP", "Help"],
  },
  gameCategoryGroups: {
    genre: "Genre",
    subject: "Subject",
    theme: "Theme",
  },
  internetExplorer: "ABCya no longer supports Internet Explorer. Please use another browser.",
  ixl: {
    title: "IXL",
  },
  join: [
    "JOIN NOW",
    "Join Now",
    "JOIN NOW",
    "JOIN NOW!",
    "JOIN NOW",
    "JOIN NOW",
    "JOIN NOW",
    "Unlock more games!",
    "Join to play!",
  ],
  last: ["LAST"],
  leaving: {
    message: "You are now leaving ABCya.com.",
    cta: "Do you want to continue?",
    disclaimer:
      "By accessing this link you will be leaving our website and entering a website hosted by another party. Please note that you will no longer be subject to, or under the protection of, our privacy and security policies. ABCya is not responsible for the information, content, or product(s) found on third-party websites.",
  },
  loading: "loading...",
  locale: {
    en: "English",
    la: "Español",
  },
  login: {
    forgot: "Forgot password",
    invalid: {
      title: "You're Logged Out!",
      description: "You have been logged out. Please log in again to keep playing games.",
    },
    legacy: "Redeem old ABCya Games subscription",
    loading: "Logging In",
    notSubscriber: "Don't have an account?",
    outConfirm: "Are you sure you would like to log out of ABCya.com?",
    title: "Account Access",
    /* premium: {
      required: "A membership is required to access this content.  Please Log In or Join Now to continue.",
    }, */
  },
  manage: {
    accountInfo: {
      current: "current:",
      student: {
        autoURL: "auto log in url:",
      },
      success: "Your account information has been updated.",
      title: ["CHANGE ACCOUNT INFO", "Change Account Info"],
      ixlSchoolContactCta:
        "To change your account information, please <a href='mailto:sales@abcya.com'>contact the sales team.</a>",
    },
    cancel: {
      canceled: "Your subscription has already been canceled and it will become a free plan on ^.",
      password: "If you would like to cancel your subscription please enter your current password.",
      success: "Your ^ has been canceled and will become a free plan on ^.",
      title: ["CANCEL SUBSCRIPTION", "Cancel Subscription"],
      warning: "Your paid account will be canceled at the end of your current billing period, which is on ^.",
    },
    close: {
      title: ["DELETE ACCOUNT"],
    },
    delete: {
      password: "If you would still like to permanently delete your account please enter your current password.",
      success: "Your account has been deleted.  You will no longer be able to log in.",
      title: ["DELETE ACCOUNT", "Delete Account"],
      warning:
        "Deleting your account will permanently delete your information from our database and you will no longer be able to log in effective immediately.",
    },
    password: "Please enter your password to make requested updates.",
    payment: {
      credit: "Update Credit Card",
      success: "Your payment information has been updated.",
      title: ["UPDATE PAYMENT INFO", "Update Payment Info"],
    },
    subscription: {
      balance: "Account balance: ^",
      messages: {
        free: "You currently have a Free Account.",
        invoiced: [
          `For assistance or more information about your account, please email us at <a href="mailto:support@abcya.com" rel="noopener noreferrer" target="_blank">support@abcya.com</a>. We're happy to help!`,
        ],
        ixl: "Your ABCya subscription is part of an IXL membership. To update or cancel your subscription, please visit:",
        ixlSchool:
          "Your ABCya subscription is part of an IXL membership. To update or cancel your subscription, please <a href='mailto:sales@abcya.com'>contact the sales team.</a>",
        legacy:
          "Please note that by changing/updating your subscription, you will opt out of the current price of ^ every ^.",
        native: ["To update or cancel your subscription, please visit:"],
        web: ["You must have a credit card on file to change your subscription plan."],
      },
      renew: "Your ^ will ^ on ^",
      success: {
        free: {
          instructions:
            "You will now be logged out and returned to our homepage. Please log back in to start enjoying your membership benefits!",
          upgraded: "Your free plan has been upgraded to a ^!",
        },
        generic: "Your subscription has been updated.",
        premium: "Your ^ has been updated.",
      },
      title: ["MANAGE SUBSCRIPTION", "Manage Subscription"],
    },
    title: ["MANAGE ACCOUNT", "Manage Account"],
    update: {
      prompt: "Please enter your current password.",
    },
  },
  mobileAppDownload: {
    title: "ABCya is better in the app!",
    noAds: "Play games with no ads",
    download: "Download games for offline play",
    smooth: "Enjoy smoother gameplay",
    continue: {
      app: "CONTINUE IN THE APP",
      browser: "Continue in browser",
    },
  },
  monthly: ["Monthly"],
  months: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  myAccount: "My Account",
  navigation: {
    close: ["CLOSE"],
    download: ["Download"],
    fullscreen: {
      exit: "Exit fullscreen",
      go: "Go fullscreen",
    },
    login: ["Login", "LOG IN", "Log&nbsp;In", "Log In"],
    logout: ["Logout", "LOG OUT", "Log Out", "Log&nbsp;Out"],
    menu: "Menu",
    print: ["Print", "PRINT"],
    search: "Search",
    open: ["Open"],
    more: ["Read More >", "Show More"],
    top: ["Back to Top"],
  },
  new: ["NEW!"],
  next: ["NEXT"],
  no: ["No"],
  none: ["NONE"],
  notfound: {
    gohome: "Go to home page",
    sorry: "I'm sorry, that ^ can't be found.",
    title: "Not Found",
    item: "content",
  },
  off: ["OFF"],
  ok: "OK",
  on: ["ON"],
  onboarding: {
    welcome: "WELCOME!",
    userType: {
      ads: "Remove advertisements completely",
      notNow: "Not now",
      play: "Play unlimited games online and offline",
      subtitle: {
        family: "ABCya makes learning fun for your whole family.",
        teacher: "ABCya makes learning fun for your whole classroom.",
      },
      unlock: {
        amount: {
          family: "5",
          teacher: "30",
        },
        copy: "Unlock subscriber access for up to ^ devices",
      },
    },
    using: {
      subtitle: "Who is using ABCya?",
      teacher: "Teacher",
      parent: "Parent",
      student: "Student",
    },
  },
  parent: ["PARENT"],
  parentsTeachers: {
    recentBlogs: "Recent Blog Entries",
    title: ["PARENTS & TEACHERS", "Parents & Teachers", "Parents&nbsp;& Teachers"],
    visit: "Visit the Blog",
  },
  password: {
    caption: [
      "Enter a new password and verify your new password to update your account.",
      "Your password was successfully updated.",
    ],
    codecta: "Copy and paste the temporary code from the email you received.",
    loading: "Updating Password",
    metaTitle: "Update Password",
    title: "UPDATE PASSWORD",
    toggle: "Click to show/hide password",
  },
  payterms: {
    title: ["PAYMENT TERMS", "Payment Terms"],
  },
  plan: ["Plan"],
  playInLocale: ["JUGAR EN ESPAÑOL", "Jugar en español", "Play in Spanish"],
  print: {
    alt: "ABCya printable image",
    cleanMessage: {
      message: "After printing, you may need to click on the art to return to the content.",
    },
    defaultFile: "ABCya_printFile",
    pdfMessage: {
      message: {
        download:
          "Your browser doesn't support PDF printing. Click the DOWNLOAD button to download the PDF file. You can then print the file directly from your PDF reader.",
        open: "Your browser doesn't support PDF printing. Click the OPEN button to open the PDF file in a separate window or tab. You can then print or save the file directly from the PDF reader.",
      },
    },
    saveMessage: {
      message:
        "Your browser doesn't support downloading from web pages. Click the OPEN button to open the file in a separate window or tab. You can then save or print the file directly from the browser.",
    },
    error: {
      sorry: "We're Sorry!",
      message: "An error occurred while printing or saving.",
    },
  },
  printables: {
    title: ["printables", "printables category", "printable"],
    go: "Go to Printables page",
    similar: {
      games: "RELATED GAMES",
    },
    meta: {
      title: "Printables",
      description: "Printable coloring pages, activities, worksheets and teacher resources by ABCya!",
      keywords: "printable, teacher resources, coloring pages, activities, worksheets",
    },
  },
  privacy: {
    title: ["PRIVACY POLICY"],
  },
  privacymobile: {
    title: ["MOBILE APP PRIVACY POLICY", "Mobile App Privacy Policy"],
  },
  promo: {
    claim: {
      example: "XXXXXXX",
    },
    checking: "Checking Coupon...",
    errors: {
      invalid: "The promo code supplied is invalid.",
    },
    applied: {
      validPlan: "$20 partner discount applied:&nbsp;<del>$79.99</del>&nbsp;$59.99 for the first year",
      invalidPlan: "To claim your $20 partner discount, please select a Yearly Plan.",
      switch: "Switch to Yearly and save.",
    },
  },
  purchasing: "Purchasing",
  redeem: {
    card: {
      anotherEmail: "TRY A DIFFERENT EMAIL ADDRESS",
      cta: "Please enter your email address:",
      free: {
        disclaim: "<p>Gift cards can be redeemed during the upgrade account process.</p>",
        message: {
          isLoggedIn:
            "<p>To redeem your gift card, you'll need an ABCya membership. Please go to Manage Account to upgrade. Once your membership is active, you'll be able to redeem your gift card.</p>",
          loggedInDiff: `<p>To redeem your gift card, you'll need an ABCya membership. Please log out of ^’s account, and log back in with ^.</p><p> Then, go to Manage Account to upgrade. Once your membership is active, you'll be able to redeem your gift card.</p>`,
          loggedOut:
            "<p>To redeem your gift card, you'll need an ABCya membership. Please log in to ABCya.com with ^ and go to Manage Account to upgrade. Once your membership is active, you'll be able to redeem your gift card.</p>",
        },
        title: "Looks like you currently have a free account.",
      },
      friends: {
        message: '<p>Please <a href="/support">contact customer support</a>.</p>',
        title: "Looks like you have a friends and family subscription.",
      },
      invoiced: {
        message: '<p>Please <a href="/support">contact customer support</a> to redeem your gift card.</p>',
        title: "Looks like you have an invoiced subscription.",
      },
      native: {
        message: `<p>Currently, only ABCya.com website subscribers can redeem ABCya gift cards.</p>
        <p>To redeem your gift card: 
          <ol>
            <li><a href="/faq#apps" rel="noopener noreferrer" target="_blank">Cancel your ABCya Games mobile app subscription</a></li>
            <li>Once your app subscription through the ^ expires, log in to ABCya.com from your desktop computer, using the same credentials you used to log in to the ABCya Games app</li>
            <li>Upgrade your account on ABCya.com.</li>
            <li>Once your membership is active on the website, you can redeem your gift card.</li>
          </ol>
        </p>`,
        title: "Looks like you currently subscribe to the ABCya Games app through the ^.",
      },
      notFound: {
        message: "<p>^ does not have an ABCya membership yet.</p><p>Join now so you can redeem your gift card!</p>",
        title: "We don't recognize that email address.",
      },
      redeemed: {
        cta: "REDEEM ANOTHER",
        message: "^ has been added to the account for ^.",
        title: "Giftcard redeemed!",
      },
      subtitle: "Let's add this credit to your account!",
      title: "We Found Your Card!",
    },
    code: "Enter Your Code:",
    giftcard: {
      title: "Redeem Your ABCya Gift Card!",
      label: "Gift Card Code",
    },
    promo: {
      title: "Redeem Your ABCya Coupon!",
      label: "Promo Code",
    },
    button: "REDEEM",
  },
  renew: ["renew"],
  rosetta: {
    title: "Rosetta Stone",
  },
  save: {
    defaultFile: "ABCya_saveFile",
  },
  school: ["school"],
  search: {
    faq: {
      answer: "Answer:",
      question: "^ question:",
    },
    filter: "Filter Results:",
    noresults: "Sorry, no search results",
    resultCounts: "^ Results (Page ^ of ^)",
    title: ["SEARCH RESULTS FOR: ^"],
    cta: "Search ^",
    mobileToggle: "Search",
    seeAll: "See All Results",
  },
  searchResults: ["Search Results"],
  send: ["SEND", "Sending"],
  signup: ["sign up", "SIGN UP"],
  spanishIngles: {
    title: "SpanishDictionary.com",
  },
  standards: {
    games: "Common Core Standards Sorted by Games",
    printables: "Common Core Standards Sorted by Printables",
    noresults: [
      "This game is not currently aligned to any Common Core standards",
      "Currently we don't have any games that meet or are assigned to this standard.",
    ],
    page: ["COMMON CORE STANDARDS PAGE", "GO TO GAME PAGE", "GO TO PRINTABLE PAGE"],
    search: "Search Standards",
    sort: "SORT BY:",
    subjects: {
      ELA: "ENGLISH LANGUAGE ARTS",
      MATH: "MATHEMATICS",
      NGSS: "NEXT GENERATION SCIENCE STANDARDS",
    },
    subtitle: ["& NEXT GENERATION SCIENCE STANDARDS"],
    title: [
      "COMMON CORE STANDARDS",
      "Common Core",
      "Common Core Standards",
      "STANDARD",
      "Standards",
      "Common&nbsp;Core Standards",
    ],
  },
  submit: ["Submit", "SUBMIT", "Submitting"],
  subscribe: {
    accessDesc: "Create an easy username and password so that your students can access the ABCya account.",
    complete: {
      code: "Completion Code",
      codecta: "Copy and paste the completion code from the email you received.",
      emailcta: "Provide address that received the completion email.",
      loading: "Completing Signup",
      thankyou: {
        autologin:
          "<p>The student access auto login url is: <strong>^</strong></p><p>The auto login url can also be found in the manage account page at any time.</p>",
        message: "Your ABCya account is all set up!",
      },
      title: ["Complete Account Signup", "COMPLETE SIGNUP"],
    },
    confirm: {
      title: "PLEASE CONFIRM",
      message: "You are about to subscribe to:",
    },
    create: "Complete Your Subscription",
    creditNotRequired: "Credit card only required if chosen plan amount is more than available account balance.",
    cta: "Choose Your Plan",
    desktopSignup: {
      title: "Unlock the Best of ABCya!",
      email: "Get the Game of the Week in your inbox",
      printable: "Access Printables for free",
      login: [
        'Already have an account? <a id="^" data-testid="^">Log in</a> here.',
        "Already have an account? Log in here.",
      ],
    },
    error: {
      accessNameExists: "It appears that the Access Name you have chosen already exists. Please choose another one.",
      existsOnDifferentPlatform:
        "It appears that you already have an ABCya account, which was purchased ^. Click OK to log in using your existing username or to retrieve your password.",
      existsOnThisPlatform:
        "It appears that you already have an ABCya account. Click OK to log in using your existing username or to retrieve your password.",
      existsOnUnknownPlatform:
        "It appears that you already have an ABCya account, which was purchase on an unknown platform. Click OK to log in using your existing username or to retrieve your password.",
      stripeInputError: "Error verifying credit card information. Please try again or contact customer support.",
      userExistsWhenSubscribed: "Email already in use. Want to <a href='/login'>log in</a> instead?",
    },
    faq: {
      title: "Frequently Asked Questions",
      data: [
        {
          question: "What do I get with an ABCya ^ membership?",
          answer: `
            With your ABCya membership, you can enjoy:
            <ul>
              <li>unlimited access to all English and Spanish games on the ABCya Games mobile apps and website</li>
              <li>offline game play via the ABCya Games mobile app</li>
              <li>an unlimited amount of saved favorite games</li>
              <li>access to tools such as the timer, category control, and fullscreen game mode</li>
            </ul>
          `,
          family: "Family",
          classroom: "Classroom",
          school: "School",
        },
        {
          question: "Is this good for more than one child?",
          answer:
            "Absolutely. A family subscription covers your entire household. All your children at home can use ABCya on supported devices with the same membership.",
          isOnlyForFamily: true,
        },
        {
          question: "What ages and grade levels is ABCya designed for?",
          answer:
            "ABCya is designed for Pre-K through Grade 6 learners. We offer games tailored to early learners up through upper elementary, with content organized by both grade level and subject area so you can easily find age‑appropriate resources.",
        },
        {
          question: "Will my students actually learn, or just play games?",
          answer:
            "ABCya's games and activities are created by educators with learning outcomes in mind. Each activity combines fun, interactive gameplay with skill‑building aligned to classroom standards. Children learn by doing, and our games reinforce essential skills through meaningful practice.",
        },
        {
          question: "Can my students play and learn in Spanish too?",
          answer:
            "Yes! Your ABCya membership gives you access to all of our games and activities in Spanish (https://la.abcya.com/), giving students the opportunity to learn and practice academic skills in their preferred language.",
        },
        {
          question: "Can ABCya be used offline?",
          answer:
            "Yes, offline gameplay is available through the ABCya Games mobile app. Once games are downloaded in the app, children can play them without an internet connection.",
        },
      ],
    },
    giftcard: {
      buying: "Buying for someone else?",
    },
    loading: "Joining!",
    options: ["MEMBERSHIP OPTIONS"],
    payment: "Payment Information",
    plans: {
      best: "BEST VALUE",
      classroom: {
        go: "Go to Classroom Membership",
        title: [
          "CLASSROOM",
          "CLASSROOM MEMBERSHIP PLANS",
          "Classroom",
          "Classroom Plan",
          "classroom plan",
          "Classroom Membership Plans",
        ],
      },
      description:
        "All prices in USD. Subscriptions renew automatically to ensure non-stop learning and fun! Cancel anytime online.",
      disclaimer: "Your membership will be renewed automatically. You can cancel online anytime.",
      family: {
        title: ["FAMILY", "FAMILY MEMBERSHIP PLANS", "Family", "Family Plan", "family plan", "Family Membership Plans"],
      },
      free: {
        title: ["FREE ACCOUNT", "Free Account", "Free Plan", "free plan"],
      },
      m1: {
        renewal: "month",
        title: ["Monthly Subscription", "monthly subscription"],
      },
      m12: {
        renewal: "12 months",
        title: ["Annual Subscription", "annual subscription"],
      },
      perks: {
        access: "Access to 300+ games",
        devices: {
          classroom: "Up to 30 devices",
          family: "Up to 5 devices",
          school: "No device limit for your school",
        },
      },
      proceed: "Proceed to ^ plan payment",
      renew: {
        month: "Billed monthly as&nbsp;^",
        year: "Billed yearly as&nbsp;^",
      },
      school: {
        back: "SELECT A PLAN",
        cta: "GET ABCya FOR YOUR SCHOOL!",
        go: "Go to School Membership",
        purchase: "PURCHASE SCHOOL SUBSCRIPTION",
        looking: "Looking for a Family or Classroom subscription?",
        title: ["SCHOOL", "SCHOOL MEMBERSHIP", "School", "School Plan", "school plan"],
        want: "Thinking bigger than the classroom?",
        requestQuote: "Request a Quote",
        rfqSubHeader: "Get ABCya for your school or district!",
        po: "We accept purchase orders for classroom and school&nbsp;subscriptions.",
        renewal: "12 months",
      },
      terms: {
        month: "per month",
        year: "per year",
      },
    },
    purchasedFrom: {
      amazon: "in the Amazon store",
      android: "in Google Play",
      ios: "in the iOS App Store",
      stripe: "at abcya.com",
    },
    rfq: {
      positions: {
        teacher: "Teacher",
        tech: "Technology Coordinator",
        principal: "Principal",
        admin: "Administrator",
        librarian: "Librarian",
        math: "Math Specialist",
        leader: "School Leader",
        other: "Other",
      },
    },
    school: {
      check: 'If you would prefer to pay by check or Purchase Order, please <a href="/support">Contact Us</a>.',
      thankyou: "Thank you for your interest in ABCya's school plan!",
      respond: "We've received your information and someone will respond to you within one business day.",
      home: "HOME",
    },
    student: "Student Access Information",
    submit: "Subscribe",
    summary: {
      family: {
        month: "ABCya Family Monthly Membership",
        annual: "ABCya Family Annual Membership",
        year: "ABCya Family Yearly Membership",
      },
      classroom: {
        annual: "ABCya Classroom Annual Membership",
      },
      school: {
        annual: "ABCya School Annual Membership",
      },
    },
    terms: `By clicking ^, you certify that you have read and agreed to our <a href="/terms" rel="noopener noreferrer" target="_blank">Terms of Use</a>, <a href="/privacy" rel="noopener noreferrer" target="_blank">Privacy Policy</a>, and <a href="/payterms" rel="noopener noreferrer" target="_blank">Payment Terms</a>.`,
    thankyou: {
      message:
        "You are now subscribed. You will soon be receiving an email with a link to verify the email address you used for your account.",
      submit: "START PLAYING GAMES!",
      title: "Thank you for joining ABCya!",
    },
    title: ["Subscribe"],
  },
  subscription: ["subscription"],
  subtotal: ["Subtotal"],
  support: {
    title: "SUPPORT",
  },
  tagline: "The Leader in Educational Games for Kids!",
  taglineIxl: "Making educational experiences better for everyone.",
  teacher: ["TEACHER"],
  terms: {
    title: ["TERMS AND CONDITIONS", "Terms of Use", "TERMS OF USE"],
  },
  thankyou: ["THANK YOU!", "Thank You!"],
  tools: {
    category: {
      instructions: "Click categories to toggle them On or Off.",
      title: ["CATEGORY CONTROL", "Category Control"],
    },
    favorite: {
      instructions: "To add more Favorite Games,",
      title: ["FAVORITE GAMES", "Favorite Games"],
    },
    timer: {
      alert: ["Time's Up!"],
      hours: "Hours",
      instructions:
        "Set a timer for the amount of time you would like to spend on ABCya. You will receive a pop-up message when your time is done.",
      minutes: "Minutes",
      remaining: "There are ^ hours, ^ minutes and ^ seconds remaining.",
      remainingNoSeconds: "There are ^ hours, ^ minutes remaining.",
      seconds: "Seconds",
      title: ["TIMER", "Timer"],
    },
    title: ["TOOLS", "Tools"],
    upgrade: "For access to this tool,",
  },
  total: ["Total"],
  tpt: {
    title: "TPT",
  },
  unlock: {
    title: ["Unlock All the Fun!"],
    message: ["Enjoy unlimited access to all 300+ ABCya games with a membership."],
  },
  update: ["UPDATE", "Updating", "Updated", "Update"],
  upgrade: {
    title: ["UPGRADE", "Upgrade", "UPGRADE", "Upgrade!"],
    message: ["A membership is required to access this content.  Upgrade today!"],
  },
  verify: {
    login: 'Please <a href="/login">log in</a> to continue.',
    metaTitle: "Verify Email Address",
    thankyou: "Thank you for confirming your email address.",
    title: "VERIFY EMAIL ADDRESS",
    verifying: "Verifying",
    notVerified: `I'm sorry, there was some trouble verifying your email address.  Please try again or <a href="/support">contact customer support</a>.`,
  },
  vocabulary: {
    title: "Vocabulary.com",
  },
  wyzant: {
    title: "Wyzant",
  },
  yearly: ["Yearly"],
  yes: ["Yes"],
};

export default strings;
